import type { LocationQueryValue } from 'vue-router';

const defaultPrefix = 'api';
const apiPrefix = 'api/api';
const chatPrefix = 'api/api/chat';
const internalPrefix = 'api/internal-api';

const Routes = {
    Auth: {
        logout: () => `/${defaultPrefix}/logout`,
        login: () => `/${defaultPrefix}/login`,
        resendEmail: () => `/${defaultPrefix}/verify/email/resend`,
        register: () => `/${defaultPrefix}/register`,
        resetPassword: () => `/${defaultPrefix}/reset-password`,
        resetPasswordToken: (token: string) =>
            `/${defaultPrefix}/reset-password/reset/${token}`,
    },
    User: {
        details: () => `/${defaultPrefix}/details`,
        closeAccount: () => `/${defaultPrefix}/close-account`,
        preferences: () => `/${apiPrefix}/me/preferences`,
        registerDecode: () => `/${defaultPrefix}/register/decode`,
        acceptNewTos: () => `/${apiPrefix}/users/updateTosVersion`,
    },
    Chat: {
        chatsByHosts: () => `/${chatPrefix}/hosts`,
        activeSessions: () => `/${chatPrefix}/active-sessions`,
        unreadMessages: () => `/${chatPrefix}/unread-messages`,
        session: (hostId: string) => `/${chatPrefix}/${hostId}`,
        markAsSent: () => `/${chatPrefix}/message/mark-as-sent`,
        markAsRead: () => `/${chatPrefix}/message/mark-as-read`,
        join: (sessionId: MaybeRef<string>) =>
            `/${chatPrefix}/join/${toValue(sessionId)}`,
    },
    Event: {
        credentials: (
            eventId: MaybeRef<LocationQueryValue | LocationQueryValue[]>
        ) => `/${defaultPrefix}/credentials/${toValue(eventId)}`,
        upcomingEvents: () => `/${internalPrefix}/event-list/upcoming`,
        pastEvents: () => `/${internalPrefix}/event-list/attended`,
    },
};

export default Routes;
